/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_DriverInputs */

const en_road_dude_clips_driver = /** @type {(inputs: Road_Dude_Clips_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The lakeside pickup`)
};

const zh_road_dude_clips_driver = /** @type {(inputs: Road_Dude_Clips_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`池塘边的皮卡`)
};

/**
* | output |
* | --- |
* | "The lakeside pickup" |
*
* @param {Road_Dude_Clips_DriverInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_driver = /** @type {((inputs?: Road_Dude_Clips_DriverInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_DriverInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_driver(inputs)
	return zh_road_dude_clips_driver(inputs)
});
export { road_dude_clips_driver as "road_dude.clips.driver" }